module.exports = __webpack_public_path__ + "img/sparta-praha-logo-icon.78bcb0eb.png";